import React, { FC, useCallback } from 'react'
import { useRecoilState, useSetRecoilState } from 'recoil';

// Mui
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { PictureList } from '../../../../components';

// Store
import { WelcomeOptionState, CalculatorStepState } from '../../../../store/calculator.store';

// Style
import { StyledContainer, StyledPaper, StyledButtonGroup } from './welcome-step.styles';

export const WelcomeStep: FC = () => {
  const [ welcomeOption, setWelcomeOption] = useRecoilState(WelcomeOptionState);
  const updateCalculatorStep = useSetRecoilState(CalculatorStepState)

  const handleCalculatorUpdate = useCallback(() => {
    switch (welcomeOption!.denumirePachet) {
      case 'ambarcatiune':
        return updateCalculatorStep('ambarcatiune');
      case 'skijet':
        return updateCalculatorStep('skijet');
      case 'peridoc':
        return updateCalculatorStep('peridoc');
      default:
        return void (0);
    }
  }, [welcomeOption, updateCalculatorStep]);

  return (
    <StyledContainer component="main" maxWidth="lg" sx={{ mb: 4 }}>
      <Typography component="h2" variant="h2" align="center">
        Cazare ambarcatiuni la <br />
        Nautic Club "Daniela Cristina"
      </Typography>

      <StyledPaper elevation={16} sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 }, borderRadius: 8 }}>
        <Grid container spacing={2}>
          <Grid component="div" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Box>
              <Typography variant="subtitle1" align="left" sx={{ lineHeight: 2 }}>
                Bine ai venit la calculatorul nostru online!. 
                Te rugăm să ne spui ce ai vrea să cazezi și vei obține cel mai bun preț din zona noastră.
              </Typography>
              
              <StyledButtonGroup>
                <Button 
                  size="large" 
                  variant={welcomeOption?.denumirePachet === 'ambarcatiune' ? 'contained' : 'outlined'}
                  sx={{ padding: 3, flex: '1 0 0', margin: '0 8px' }}
                  onClick={() => setWelcomeOption({ denumirePachet: 'ambarcatiune', indxPachet: 0 })}
                >
                  Ambarcațiune
                </Button>
                <Button 
                  size="large" 
                  variant={welcomeOption?.denumirePachet === 'skijet' ? 'contained' : 'outlined'}
                  sx={{ padding: 3, flex: '1 0 0', margin: '0 8px' }}
                  onClick={() => setWelcomeOption({ denumirePachet: 'skijet', indxPachet: 1 })}
                >
                  Skijet
                </Button>
                <Button 
                  size="large" 
                  variant={welcomeOption?.denumirePachet === 'peridoc' ? 'contained' : 'outlined'}
                  sx={{ padding: 3, flex: '1 0 0', margin: '0 8px' }}
                  onClick={() => setWelcomeOption({ denumirePachet: 'peridoc', indxPachet: 2 })}
                >
                  Doar peridoc
                </Button>
              </StyledButtonGroup>

              <Button 
                size="large" 
                disabled={!welcomeOption}
                variant="contained"
                sx={{ width: '100%', mt: 4 }}
                onClick={() => handleCalculatorUpdate()}
              >
                Pasul următor 
              </Button>
            </Box>
          </Grid>
          <Grid component="div" sx={{}}>
            <Card sx={{ maxHeight: '640px', borderRadius: 8 }}>
              <PictureList
                list={[
                  { webP: '/assets/images/cazare-ambarcatiuni.webp', jpg: '/assets/images/cazare-ambarcatiuni.jpg' },
                  { webP: '/assets/images/cazare-jetsky.webp', jpg: '/assets/images/cazare-jetsky.jpg' },
                  { webP: '/assets/images/cazare-peridoc.webp', jpg: '/assets/images/cazare-peridoc.jpg' },
                ]}
                activeItem={welcomeOption?.indxPachet || 0}
              />
            </Card>
          </Grid>          
        </Grid>
      </StyledPaper>
    </StyledContainer>
  )
}